import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useExportImportHistory } from '../../hooks/useExportImportHistory';
import type { ImportHistoryFilters } from '../../adapters/ImportHistoryApiAdapter';

interface Props {
  /** Filtros para exportar (searchTerm, filterConditions, etc.) */
  filters: ImportHistoryFilters & {
    searchTerm?: string;
    filterConditions?: any[];
  };
}

export const DownloadExcelButton: React.FC<Props> = ({ filters }) => {
  const { t } = useTranslation('shopsModule');
  const { exportToExcel, isExporting } = useExportImportHistory();

  const handleDownload = () => {
    exportToExcel(filters);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 !text-icons transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="download-excel-button"
    >
      <FontAwesomeIcon icon={faFileArrowDown} className="!text-icons" />
    </Button>
  );
};
